import React from "react";
import PropTypes from "prop-types";
import { buildScopeTranslate } from "lib/I18n";
import { refPropType } from "../utils";

const DEFAULT_SCOPE = "views.content.agentforce.assessments.pages.error";

const ErrorScreen = ({ message = null, onRetry = null, onBackToTrail, scope = DEFAULT_SCOPE, testIds = {}, headingRef = null }) => {
  const tError = buildScopeTranslate(scope);
  const isDefaultMessage = !message;
  const ids = {
    screen: "error-screen",
    heading: "error-heading-default",
    message: isDefaultMessage ? "error-message-default" : "error-message-custom",
    ...testIds,
  };

  return (
    <div className="slds-align_absolute-center slds-grid slds-grid_vertical slds-grid_align-center slds-p-around_xx-large" data-testid={ids.screen}>
      <div className="slds-text-align_center th-agentforce-assessment__error-content">
        <div role="alert" className="th-sr-only">
          {message || tError("default_message")}
        </div>
        <h1
          ref={headingRef}
          className="th-agentforce-assessment__result-heading"
          data-testid={ids.heading}
          tabIndex="-1">
          {tError("title")}
        </h1>
        <p
          className="slds-text-body_regular slds-m-bottom_large th-agentforce-assessment__text-subtle"
          data-testid={ids.message}
        >
          {message || tError("default_message")}
        </p>
        <div className="slds-grid slds-grid_align-center slds-gutters_small">
          <div className="slds-col">
            <tds-button variant="neutral" onClick={onBackToTrail} data-testid="error-back-btn">
              <span>{tError("buttons.back")}</span>
            </tds-button>
          </div>
          {onRetry && (
            <div className="slds-col">
              <tds-button variant="brand" icon-symbol="refresh" onClick={onRetry} data-testid="error-retry-btn">
                <span>{tError("buttons.retry")}</span>
              </tds-button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ErrorScreen.propTypes = {
  message: PropTypes.string,
  onRetry: PropTypes.func,
  onBackToTrail: PropTypes.func.isRequired,
  // i18n scope for the title/message/button copy. Override to reuse this screen
  // outside the agentforce assessment (e.g. the modular assessment framework).
  scope: PropTypes.string,
  // Override the screen/heading/message data-testids when the host UI needs
  // its own selectors. Buttons keep their shared testids.
  testIds: PropTypes.shape({
    screen: PropTypes.string,
    heading: PropTypes.string,
    message: PropTypes.string,
  }),
  headingRef: refPropType,
};

export default ErrorScreen;
